import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { GaEventsService } from 'src/app/_services/ga-events.service';
import { SearchtoolboxService } from 'src/app/_services/searchtoolbox.service';
import { FreemiumAPIService } from 'src/app/webtree-website/freemium-api.service';

@Component({
    selector: 'app-marketing-modal',
    templateUrl: './marketing-modal.component.html',
    styleUrls: ['./marketing-modal.component.scss'],
    standalone: false
})
export class MarketingModalComponent implements OnInit {
freeTrialForm: UntypedFormGroup = new UntypedFormGroup({
    workEmail: new UntypedFormControl(null, Validators.compose([Validators.required, Validators.pattern('^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$')])),
  })
showErrorMsg: string;
  @ViewChild("freeTrialSuccess") freeTrialSuccess: TemplateRef<NgbModalRef>;
  response: any;
  showFreeTrialLoader: Boolean = false;
  @Input() message:any;
  successMessage: string = '';
  errorMessage: string = '';
  constructor( private activeModal: NgbActiveModal, private searchtoolbox: SearchtoolboxService, private modalService: NgbModal, private freemiumApiService: FreemiumAPIService, private gaService: GaEventsService) { }

  ngOnInit() {
  }
  dismiss(){
    this.modalService.dismissAll()
  }
   requestFreeTrial() {
    this.showErrorMsg = null;

    if(this.freeTrialForm.valid) {
      this.showFreeTrialLoader = true;

      const request = {
        message: this.message,
        emailid: this.freeTrialForm.getRawValue().workEmail
      }
      this.freemiumApiService.exportFreemiumSkillTaxonomy(request).subscribe((res:any) => {
        this.response = res;
        this.showFreeTrialLoader = false;

        if(this.response && this.response.status == "success") {
          this.modalService.dismissAll()
          const modalRef = this.modalService.open(this.freeTrialSuccess, {
            size: "modal-free-trial-success",
            centered: true,
            backdrop: "static",
            keyboard: false,
          });
           setTimeout(() => {this.modalService.dismissAll(this.freeTrialSuccess);
          }, 3000);
          this.freeTrialForm.reset();
      /**
     * GA tracking for Insights page visit
     */
    this.gaService.trackButtonClick('Unlock_Skill_Taxonomy_Graph');
        }
       }, (err:any)=>{
        this.showFreeTrialLoader = false;
        this.errorMessage = "Something went wrong while exporting the skill taxonomy data. Please try again.";
        setTimeout(()=>{
          this.errorMessage = '';
          this.modalService.dismissAll();
          this.freeTrialForm.reset();

        })

           })
    }



  }
}
